import './Stepper.scss'
import React from 'react'
import {
    Stepper as StepperMaterial,
    StepLabel,
    Step,
    withStyles,
    makeStyles,
    StepConnector,
    // MobileStepper
} from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { ReactComponent as Check } from './check.svg'
import colors from '../../mixins.scss'

const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    active: {
        '& $line': {
            borderColor: colors.svBlue,
        },
    },
    completed: {
        '& $line': {
            borderColor: colors.svBlue,
        },
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: colors.svBlue,
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: colors.svBlue,
        zIndex: 1,
        fontSize: 18,
    },
    progress: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    }
});

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};

const useStyles = makeStyles(() => ({
    root: {
        padding: 0
    }
}));

const Stepper = (props) => {
    const classes = useStyles();

    // const [activeStep, setActiveStep] = React.useState(0);

    // const handleNext = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    // };

    // const handleBack = () => {
    //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // };

    return props.isShow ? (
        <div className={'stepper'}>
            <StepperMaterial className={classes.root} alternativeLabel activeStep={props.activeStep || 0} connector={
                <QontoConnector />
                // <MobileStepper
                //     variant="progress"
                //     steps={10}
                //     position="static"
                //     activeStep={10}
                //     // className={classes.progress}
                // />
            }>
                {props.steps.map((step, index) => (
                    <Step key={index}>
                        <StepLabel StepIconComponent={QontoStepIcon}>{step}</StepLabel>
                    </Step>
                ))}
            </StepperMaterial>
        </div>
    ) : null
}

export default Stepper
